import { render, staticRenderFns } from "./RehabCoursesMy.vue?vue&type=template&id=9cca6f40&scoped=true"
import script from "./RehabCoursesMy.vue?vue&type=script&lang=js"
export * from "./RehabCoursesMy.vue?vue&type=script&lang=js"
import style0 from "./RehabCoursesMy.vue?vue&type=style&index=0&id=9cca6f40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cca6f40",
  null
  
)

export default component.exports